/**
 * Toggle pill for filters and pickers. Always a real <button> with aria-pressed.
 * tone="brand"   : blue when pressed (on white / tinted backgrounds)
 * tone="sun"     : orange when pressed (use sparingly)
 * tone="onBrand" : white when pressed (on a blue panel)
 */
const PRESSED = {
  brand: "bg-brand-500 border-brand-500 text-white",
  sun: "bg-brand-100 border-brand-200 text-ink",
  onBrand: "bg-brand-500 border-brand-500 text-white",
};

const IDLE = {
  brand: "bg-white border-brand-200 text-ink hover:border-brand-500 hover:bg-brand-50",
  sun: "bg-white border-brand-200 text-ink hover:border-brand-500 hover:bg-brand-50",
  onBrand: "bg-white border-brand-200 text-ink hover:border-brand-500",
};

export function Chip({ pressed = false, tone = "brand", onClick, children, className = "", ...rest }) {
  const state = pressed ? (PRESSED[tone] ?? PRESSED.brand) : (IDLE[tone] ?? IDLE.brand);

  return (
    <button
      type="button"
      aria-pressed={pressed}
      onClick={onClick}
      className={`min-h-[44px] rounded-full border px-5 py-2 text-sm font-semibold transition-colors sm:text-base ${state} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
